import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-agent-identity-label',
  templateUrl: './agent-identity-label.component.html',
  styleUrl: './agent-identity-label.component.scss',
})
export class AgentIdentityLabelComponent {
  @Input() visualName?: string | null;
  @Input() internalName?: string | null;
  @Input() fallback?: string | null;
  @Input() compact = false;

  get displayName(): string {
    return (
      this.normalize(this.visualName) ||
      this.normalize(this.internalName) ||
      this.normalize(this.fallback) ||
      ''
    );
  }

  get internalTag(): string {
    const internalName = this.normalize(this.internalName);
    if (!internalName || internalName === this.displayName) {
      return '';
    }
    return internalName;
  }

  private normalize(value?: string | null): string {
    return (value || '').trim();
  }
}
